const Headline = ({text}) => {
    return(<div className="portfolio_headline">{text}</div>)
}

export default Headline;